module.exports = __webpack_public_path__ + "img/ltkvideo-4x.bb53b2f.jpg";